export type PartnerOnboardingStatus = 'ONBOARDED' | 'APPROVED_TARGET' | 'PRIO_A' | 'INVITED' | 'IN_TALKS';

export interface TopBestandsMakler {
  kd: string;
  firma: string;
  person: string;
  email: string;
  telefon: string;
  plz2: string;
  regionName: string;
  ligaBadge?: string;
  salesCount: number;
  auftragCount: number;
  leadsGesamt: number;
  kontingentWoche: number;
  reklamationsquote: number;
  hinweis?: string;
  status: PartnerOnboardingStatus;
}

export interface ExcludedBroker {
  kd: string;
  firma: string;
  grund: string;
  beleg: string;
}

export interface FreeTerritorySlot {
  plz2: string;
  regionName: string;
  ligaClub: string;
  bundesland: string;
  potentialLeadsMonth: number;
  recommendedTier: string;
}

export interface NewCustomerCandidate {
  id: string;
  firma: string;
  person: string;
  plz2: string;
  regionName: string;
  email: string;
  telefon: string;
  stage: 'NEU' | 'QUALIFIZIERT' | 'VERTRAG_GESENDET' | 'AKTIV';
  note: string;
}

// Von Dominik kuratierte & gebietsbereinigte Maklerpass-Auswahl (23.10.2026):
// - Berlin/Brandenburg (PLZ 10–16) exklusiv bei BETA Project & Immobilien GmbH (Andreas Pfau) – L&S und Lochmann/AKZENT ausgeschlossen.
// - Direkt gesetzte Top-Partner (Gómez, Logis/Schulte, Sczuka, Schönheit, Hegenbart, Bergmann, Bremer, Immo2you,
//   Flöttmann, Patrick Homes, Königskinder Lisa Makowitz / Hauptbüro, Buchenau München) + alle 1. & 2. Bundesliga-Standorte.
export const TOP_BESTANDS_MAKLER: TopBestandsMakler[] = [
  {
    kd: '100701',
    firma: 'BETA Project & Immobilien GmbH',
    person: 'Andreas Pfau',
    email: 'a.pfau@beta-project-immobilien.de',
    telefon: '+49 151 74204146',
    plz2: '10–14',
    regionName: 'Berlin & Brandenburg (Exklusiv-Gesamtgebiet)',
    ligaBadge: '1. BL Union Berlin · 2. BL Hertha BSC',
    salesCount: 8,
    auftragCount: 16,
    leadsGesamt: 1574,
    kontingentWoche: 10,
    reklamationsquote: 0.0,
    status: 'ONBOARDED',
  },
  {
    kd: '100514',
    firma: 'W&F Wohnfinanz GmbH',
    person: 'José Gómez',
    email: 'jg@wohnfinanz24.de',
    telefon: '+49 171 2728330',
    plz2: '65',
    regionName: 'Wiesbaden / Mainz / Frankfurt-West',
    ligaBadge: '1. BL Eintracht Frankfurt & Mainz 05 · 2. BL SVWW',
    salesCount: 21,
    auftragCount: 5,
    leadsGesamt: 671,
    kontingentWoche: 4,
    reklamationsquote: 12.2,
    status: 'APPROVED_TARGET',
  },
  {
    kd: '100242',
    firma: 'Buchenau Immobilien (München)',
    person: 'Ralf Buchenau',
    email: 'rb@immobilien-buchenau.de',
    telefon: '+49 172 8569693',
    plz2: '80/85',
    regionName: 'München & Großraum München',
    ligaBadge: '1. BL FC Bayern München',
    salesCount: 18,
    auftragCount: 2,
    leadsGesamt: 572,
    kontingentWoche: 5,
    reklamationsquote: 12.2,
    hinweis: 'Hinweis: 04/2025 Gutschrift-Streit (4.590 €) mit Anwalts-Erwähnung, Ton aber sachlich – vor Einladung Guthaben klären.',
    status: 'APPROVED_TARGET',
  },
  {
    kd: '101459',
    firma: 'Immobilien Schoenheit',
    person: 'Heike Schönheit',
    email: 'heike.schoenheit@immobilien-schoenheit.de',
    telefon: '+49 1525 2359786',
    plz2: '40',
    regionName: 'Düsseldorf / Mettmann / Ratingen',
    ligaBadge: '2. BL Fortuna Düsseldorf',
    salesCount: 10,
    auftragCount: 1,
    leadsGesamt: 123,
    kontingentWoche: 3,
    reklamationsquote: 8.1,
    status: 'APPROVED_TARGET',
  },
  {
    kd: '100921',
    firma: 'Die Makler Immobilien-Team Hegenbart e.K.',
    person: 'Jörg Hegenbart',
    email: 'info@hegenbart-online.de',
    telefon: '+49 160 5333389',
    plz2: '51/50',
    regionName: 'Köln & Leverkusen / Bergisch Gladbach',
    ligaBadge: '1. BL Bayer 04 Leverkusen · 2. BL 1. FC Köln',
    salesCount: 9,
    auftragCount: 3,
    leadsGesamt: 295,
    kontingentWoche: 5,
    reklamationsquote: 18.3,
    hinweis: 'Zahlungsregelung RE-19259/19260 (01/2026) offen – vor Einladung Buchhaltung prüfen.',
    status: 'APPROVED_TARGET',
  },
  {
    kd: '100869',
    firma: 'Sczuka Immobilien',
    person: 'Erwin Sczuka',
    email: 'info@sczuka-immobilien.de',
    telefon: '+49 163 8887732',
    plz2: '34',
    regionName: 'Kassel & Nordhessen',
    ligaBadge: 'Oberzentrum Nordhessen',
    salesCount: 9,
    auftragCount: 6,
    leadsGesamt: 250,
    kontingentWoche: 3,
    reklamationsquote: 11.2,
    hinweis: '08/2026 scharfe Reklamation (Lead Göbel: „falsche Angaben“) – Ton grenzwertig, Dominik entscheidet.',
    status: 'APPROVED_TARGET',
  },
  {
    kd: '100193',
    firma: 'Bergmann Immobilien',
    person: 'Norbert Bergmann',
    email: 'info@bergmann-immobilien-norden.de',
    telefon: '+49 4931 979000',
    plz2: '26',
    regionName: 'Oldenburg / Ostfriesland / Wilhelmshaven',
    ligaBadge: 'Nordwest-Region',
    salesCount: 9,
    auftragCount: 2,
    leadsGesamt: 184,
    kontingentWoche: 2,
    reklamationsquote: 21.2,
    hinweis: 'Reklamationsquote hoch (21 %), Ton stets korrekt.',
    status: 'APPROVED_TARGET',
  },
  {
    kd: '101358',
    firma: 'Patrick Homes',
    person: 'Patrick Mugele',
    email: 'p.mugele@patrickhomes.de',
    telefon: '+49 176 70865432',
    plz2: '70/71',
    regionName: 'Stuttgart & Region Württemberg',
    ligaBadge: '1. BL VfB Stuttgart',
    salesCount: 7,
    auftragCount: 3,
    leadsGesamt: 143,
    kontingentWoche: 3,
    reklamationsquote: 42.0,
    hinweis: 'ACHTUNG: 42 % Reklamationsquote + Kündigung 09/2026 („nicht weiterhin beliefert werden“) – Dominik hat ihn namentlich gesetzt, bitte final bestätigen.',
    status: 'APPROVED_TARGET',
  },
  {
    kd: '101163',
    firma: 'Horst Flöttmann Immobilien Planen + Bauen GmbH',
    person: 'Marcel Friske',
    email: 'post@floettmann-immobilien.de',
    telefon: '+49 521 402055',
    plz2: '33',
    regionName: 'Bielefeld / Paderborn / Gütersloh',
    ligaBadge: '2. BL SC Paderborn 07 · Arminia Bielefeld',
    salesCount: 6,
    auftragCount: 3,
    leadsGesamt: 431,
    kontingentWoche: 10,
    reklamationsquote: 6.5,
    status: 'APPROVED_TARGET',
  },
  {
    kd: '101355',
    firma: 'Friedhelm Bremer Immobilien',
    person: 'Friedhelm Bremer',
    email: 'immobilien@derimmobilienfuchs.de',
    telefon: '+49 172 9500396',
    plz2: '41',
    regionName: 'Mönchengladbach / Neuss / Viersen',
    ligaBadge: '1. BL Borussia Mönchengladbach',
    salesCount: 5,
    auftragCount: 2,
    leadsGesamt: 135,
    kontingentWoche: 2,
    reklamationsquote: 17.8,
    status: 'APPROVED_TARGET',
  },
  {
    kd: '101414',
    firma: 'Königskinder Immobilien – Makowitz Immobilien',
    person: 'Lisa Makowitz',
    email: 'makowitz@koenigskinder.de',
    telefon: '+49 1575 3577808',
    plz2: '79',
    regionName: 'Freiburg im Breisgau / Südbaden / Schwarzwald',
    ligaBadge: '1. BL SC Freiburg',
    salesCount: 4,
    auftragCount: 2,
    leadsGesamt: 136,
    kontingentWoche: 5,
    reklamationsquote: 13.2,
    status: 'APPROVED_TARGET',
  },
  {
    kd: '100183',
    firma: 'Wohnsitz LE GmbH',
    person: 'Antonio Pienitz',
    email: 'lead-maklerplan@wohnsitz-le.de',
    telefon: '+49 341 87085938',
    plz2: '04',
    regionName: 'Leipzig & Nordsachsen',
    ligaBadge: '1. BL RB Leipzig',
    salesCount: 16,
    auftragCount: 13,
    leadsGesamt: 271,
    kontingentWoche: 4,
    reklamationsquote: 14.0,
    status: 'PRIO_A',
  },
  {
    kd: '100894',
    firma: 'Maha Kurt Immobilien',
    person: 'Maha Kurt',
    email: 'maha.kurt@icloud.com',
    telefon: '+49 1522 3860924',
    plz2: '49',
    regionName: 'Osnabrück / Emsland',
    ligaBadge: 'VfL Osnabrück',
    salesCount: 12,
    auftragCount: 17,
    leadsGesamt: 262,
    kontingentWoche: 5,
    reklamationsquote: 9.9,
    status: 'PRIO_A',
  },
  {
    kd: '100945',
    firma: 'Dickerhoff Immobilien',
    person: 'Stefan Dickerhoff',
    email: 'stefan.dickerhoff@dickerhoff-immobilien.de',
    telefon: '+49 231 20652285',
    plz2: '44',
    regionName: 'Dortmund & östliches Ruhrgebiet',
    ligaBadge: '1. BL Borussia Dortmund (BVB)',
    salesCount: 8,
    auftragCount: 5,
    leadsGesamt: 163,
    kontingentWoche: 3,
    reklamationsquote: 12.9,
    status: 'PRIO_A',
  },
  {
    kd: '101158',
    firma: 'Grounded GmbH',
    person: 'Geschäftsführung',
    email: 'grounded_immobilien@icloud.com',
    telefon: '+49 911 47756799',
    plz2: '90',
    regionName: 'Nürnberg / Fürth / Erlangen',
    ligaBadge: '2. BL 1. FC Nürnberg & SpVgg Greuther Fürth',
    salesCount: 6,
    auftragCount: 2,
    leadsGesamt: 315,
    kontingentWoche: 3,
    reklamationsquote: 9.8,
    status: 'PRIO_A',
  },
  {
    kd: '101460',
    firma: 'Mein Makler Bruchsal',
    person: 'Jochen Reinhold',
    email: 'jochen.reinhold@mein-makler.com',
    telefon: '+49 1579 2368169',
    plz2: '76',
    regionName: 'Karlsruhe / Bruchsal / Baden',
    ligaBadge: '2. BL Karlsruher SC (KSC)',
    salesCount: 5,
    auftragCount: 5,
    leadsGesamt: 188,
    kontingentWoche: 3,
    reklamationsquote: 21.8,
    hinweis: 'Reklamationsquote hoch (22 %), Ton stets korrekt.',
    status: 'PRIO_A',
  },
  {
    kd: '101373',
    firma: 'AUSA Immobilienmakler GmbH',
    person: 'Aaron August',
    email: 'leads@ausa-immobilien.de',
    telefon: '+49 251 29795162',
    plz2: '48',
    regionName: 'Münster & Münsterland',
    ligaBadge: '2. BL Preußen Münster',
    salesCount: 5,
    auftragCount: 2,
    leadsGesamt: 133,
    kontingentWoche: 2,
    reklamationsquote: 14.3,
    status: 'PRIO_A',
  },
  {
    kd: '100160',
    firma: 'HBF Immobilien GmbH',
    person: 'Andreas Poth',
    email: 'andreas.poth@hbf-immo.de',
    telefon: '+49 40 53809915',
    plz2: '20/22',
    regionName: 'Hamburg & Metropolregion',
    ligaBadge: '1. BL FC St. Pauli · 2. BL Hamburger SV',
    salesCount: 4,
    auftragCount: 2,
    leadsGesamt: 371,
    kontingentWoche: 4,
    reklamationsquote: 10.2,
    status: 'PRIO_A',
  },
  {
    kd: '101496',
    firma: 'Deutsche Bank Immobilien GmbH (Kiel)',
    person: 'Thomas Grünes',
    email: 'thomas.gruenes@db.com',
    telefon: '+49 151 50987866',
    plz2: '24',
    regionName: 'Kiel & Schleswig-Holstein Ost',
    ligaBadge: '1. BL Holstein Kiel',
    salesCount: 3,
    auftragCount: 5,
    leadsGesamt: 95,
    kontingentWoche: 3,
    reklamationsquote: 14.7,
    status: 'PRIO_A',
  },
];

// Ausgeschlossen (Dominik 23.10.2026: „alle, die reklamieren und respektlos geschrieben haben, nicht“ – Postfach-Prüfung 2020–2026).
export const EXCLUDED_BROKERS: ExcludedBroker[] = [
  { kd: '101184', firma: 'Immo2you GmbH (Klaus Gräber)', grund: 'Ausdrückliche Vorgabe Dominik: „auf keinen Fall“', beleg: 'Entscheidung 23.10.2026' },
  { kd: '100570', firma: 'Logis Immobilien Service (Frank Schulte)', grund: 'Respektlos & 28,9 % Reklamationsquote', beleg: '08.09.2026: „das ist doch wohl ein Witz … absolut unseriös … Anruf Ihres Vorgesetzten“' },
  { kd: '101433', firma: 'Finest Properties Hannover (Christopher Grein)', grund: 'Respektlos, Zahlungsverweigerung & 30,1 % Reklamationsquote', beleg: '05.03.2026: „ob Sie mich verarschen wollen“ · 02.08.2022: „werde ich nicht bezahlen“' },
  { kd: '101543', firma: 'KLIMAS IMMOBILIEN GmbH (Klimaschewski)', grund: 'Rechnungsstreit mit Drohkulisse', beleg: '10.06.2026: „Letztmalige Aufforderung zur Einstellung weiterer Zahlungsaufforderungen“' },
  { kd: '100883', firma: 'EURO-Finanz Immobilien (Johann Janker)', grund: 'Respektlos gegenüber Team', beleg: '08.08.2022: „ich habe bisher allen Schrott an Leads bezahlt“' },
  { kd: '101261', firma: 'AMG Immobilien GmbH (Augsburg)', grund: 'Kündigung & 21,3 % Reklamationsquote', beleg: '22.09.2025: Vertragskündigung zum nächstmöglichen Termin' },
  { kd: '101179', firma: 'L&S Vermögensverwaltungs GmbH (Lüdenbach)', grund: 'Gebiet Berlin exklusiv bei BETA Project', beleg: 'Entscheidung 23.10.2026' },
  { kd: '100105', firma: 'AKZENT Finanz- und Immobilienservice (Lochmann)', grund: 'Gebiet Berlin exklusiv bei BETA Project', beleg: 'Entscheidung 23.10.2026' },
];

// Freie 1. & 2. Bundesliga-Standorte für die Sparte „Neukunden Maklerpass“ (exklusiv 1 Partner je Standort).
export const FREE_TERRITORY_SLOTS: FreeTerritorySlot[] = [
  { plz2: '60', regionName: 'Frankfurt am Main (City / Bankenviertel)', ligaClub: '1. BL Eintracht Frankfurt', bundesland: 'Hessen', potentialLeadsMonth: 48, recommendedTier: '1. Bundesliga Metropole' },
  { plz2: '38', regionName: 'Wolfsburg / Braunschweig', ligaClub: '1. BL VfL Wolfsburg · 2. BL Eintracht Braunschweig', bundesland: 'Niedersachsen', potentialLeadsMonth: 32, recommendedTier: '1. & 2. Bundesliga' },
  { plz2: '74', regionName: 'Sinsheim / Heilbronn / Kraichgau', ligaClub: '1. BL TSG 1899 Hoffenheim', bundesland: 'Baden-Württemberg', potentialLeadsMonth: 28, recommendedTier: '1. Bundesliga' },
  { plz2: '89', regionName: 'Heidenheim / Ulm', ligaClub: '1. BL 1. FC Heidenheim · 2. BL SSV Ulm 1846', bundesland: 'Baden-Württemberg', potentialLeadsMonth: 29, recommendedTier: '1. & 2. Bundesliga' },
  { plz2: '67', regionName: 'Kaiserslautern / Ludwigshafen / Pfalz', ligaClub: '2. BL 1. FC Kaiserslautern', bundesland: 'Rheinland-Pfalz', potentialLeadsMonth: 27, recommendedTier: '2. Bundesliga Traditionsstandort' },
  { plz2: '64', regionName: 'Darmstadt & Südhessen', ligaClub: '2. BL SV Darmstadt 98', bundesland: 'Hessen', potentialLeadsMonth: 26, recommendedTier: '2. Bundesliga' },
  { plz2: '39', regionName: 'Magdeburg & Börde', ligaClub: '2. BL 1. FC Magdeburg', bundesland: 'Sachsen-Anhalt', potentialLeadsMonth: 24, recommendedTier: '2. Bundesliga' },
  { plz2: '66', regionName: 'Elversberg / Saarbrücken / Saarland', ligaClub: '2. BL SV Elversberg · 1. FC Saarbrücken', bundesland: 'Saarland', potentialLeadsMonth: 23, recommendedTier: '2. Bundesliga' },
  { plz2: '86', regionName: 'Augsburg & Bayerisch-Schwaben', ligaClub: '1. BL FC Augsburg', bundesland: 'Bayern', potentialLeadsMonth: 30, recommendedTier: '1. Bundesliga' },
  { plz2: '28', regionName: 'Bremen & Umland', ligaClub: '1. BL SV Werder Bremen', bundesland: 'Bremen', potentialLeadsMonth: 26, recommendedTier: '1. Bundesliga' },
  { plz2: '30', regionName: 'Hannover & Region', ligaClub: '2. BL Hannover 96', bundesland: 'Niedersachsen', potentialLeadsMonth: 29, recommendedTier: '2. Bundesliga' },
  { plz2: '93', regionName: 'Regensburg & Oberpfalz', ligaClub: '2. BL SSV Jahn Regensburg', bundesland: 'Bayern', potentialLeadsMonth: 21, recommendedTier: '2. Bundesliga' },
  { plz2: '53', regionName: 'Bonn / Rhein-Sieg-Kreis', ligaClub: 'Metropolregion Rheinland', bundesland: 'Nordrhein-Westfalen', potentialLeadsMonth: 27, recommendedTier: 'Regional-Exklusiv' },
  { plz2: '01', regionName: 'Dresden & Elbtal', ligaClub: 'Dynamo Dresden (Metropolstandort)', bundesland: 'Sachsen', potentialLeadsMonth: 34, recommendedTier: 'Top-Ballungsraum' },
  { plz2: '18', regionName: 'Rostock & Ostseeküste', ligaClub: 'Hansa Rostock', bundesland: 'Mecklenburg-Vorpommern', potentialLeadsMonth: 22, recommendedTier: 'Traditionsstandort' },
];

export interface StaffelBreakdown {
  objectPrice: number;
  auftragFeeEur: number;
  auftragTierLabel: string;
  saleParticipationPercent: number;
  saleParticipationEur: number;
  totalMaklerpassRevenueEur: number;
  brokerNetCommissionEur: number;
}

export function calculateMaklerpassStaffel(objectPrice: number, totalCommissionPercent = 7.14): StaffelBreakdown {
  let auftragFeeEur = 490;
  let auftragTierLabel = 'Staffel 1 (Objektwert bis 300.000 €)';
  if (objectPrice >= 1_500_000) {
    auftragFeeEur = 1490;
    auftragTierLabel = 'Staffel 4 (Großobjekt ab 1.500.000 €)';
  } else if (objectPrice >= 750_000) {
    auftragFeeEur = 1190;
    auftragTierLabel = 'Staffel 3 (Objektwert 750.000 € – 1.500.000 €)';
  } else if (objectPrice >= 300_000) {
    auftragFeeEur = 790;
    auftragTierLabel = 'Staffel 2 (Objektwert 300.000 € – 750.000 €)';
  }

  let saleParticipationPercent = 5.0;
  if (objectPrice >= 1_500_000) {
    saleParticipationPercent = 4.0;
  } else if (objectPrice >= 500_000) {
    saleParticipationPercent = 4.5;
  }

  const totalBrokerGrossCommission = Math.round((objectPrice * totalCommissionPercent) / 100);
  const saleParticipationEur = Math.round((totalBrokerGrossCommission * (saleParticipationPercent * 4)) / 100);
  const totalMaklerpassRevenueEur = auftragFeeEur + saleParticipationEur;
  const brokerNetCommissionEur = Math.max(0, totalBrokerGrossCommission - totalMaklerpassRevenueEur);

  return {
    objectPrice,
    auftragFeeEur,
    auftragTierLabel,
    saleParticipationPercent,
    saleParticipationEur,
    totalMaklerpassRevenueEur,
    brokerNetCommissionEur,
  };
}
